module.exports = __webpack_public_path__ + "static/media/squash_caviar_peekle.31f9ace5.png";